// src/api/listsApi.js
import { AUTH_TOKEN_KEY, getAuthHeaders } from './authApi';
import { API_BASE_URL } from '../config/apiConfig';

const parseResponse = async (response) => {
  const data = await response.json();

  if (response.status === 401) {
    localStorage.removeItem(AUTH_TOKEN_KEY);
    window.dispatchEvent(new Event('auth:unauthorized'));
  }

  if (!response.ok || data.success === false) {
    throw new Error(data.message || `HTTP Error: ${response.status}`);
  }

  return data;
};

const listsApi = {
  fetchLists: async () => {
    const response = await fetch(`${API_BASE_URL}list-list.php`, {
      headers: getAuthHeaders(),
    });

    return parseResponse(response);
  },

  createList: async (name) => {
    const response = await fetch(`${API_BASE_URL}list-insert.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders(),
      },
      body: JSON.stringify({ name }),
    });

    return parseResponse(response);
  },

  updateList: async (id, name) => {
    const response = await fetch(`${API_BASE_URL}list-edit.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders(),
      },
      body: JSON.stringify({ id, name }),
    });

    return parseResponse(response);
  },

  deleteList: async (id) => {
    const response = await fetch(`${API_BASE_URL}list-delete.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders(),
      },
      body: JSON.stringify({ id }),
    });

    return parseResponse(response);
  },
};

export { listsApi };
